// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__AsZkT","flow":"styles_flow__Y4yHJ"};